import { render } from "./sedes.vue?vue&type=template&id=2c92bd58&scoped=true"
import script from "./sedes.vue?vue&type=script&lang=js"
export * from "./sedes.vue?vue&type=script&lang=js"

import "./sedes.vue?vue&type=style&index=0&id=2c92bd58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c92bd58"]])

export default __exports__